const URL_FRAGMENT_DELIMITER = '#';

export const getCurrentURLHashFragment = () =>
  (window?.location?.hash || window?.location?.href || '').split(
    URL_FRAGMENT_DELIMITER
  )[1];
